import { Helmet } from 'react-helmet-async';

import { TripPackageCards } from './_authenticated._main.trips.trip-package/TripPackageCards';
import { TripPackageTable } from './_authenticated._main.trips.trip-package/TripPackageTable';
import { t } from '../services/translation/translation';

export const TripsPackageRoute = () => {
  return (
    <div>
      <Helmet>
        <title>{t('side-bar.trips-calendar')} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white mb-6">{t('side-bar.trips-packages')}</h3>
      <div className="hidden xl:block">
        <TripPackageTable />
      </div>
      <div className="xl:hidden justify-center flex">
        <TripPackageCards />
      </div>
    </div>
  );
};
